import styled from "styled-components";

export const DealersContainer = styled.div`
    position: relative;
    height: 100%;

    .selected-card {
        border: 2px solid #389e0d !important;
    }
`

export const Overlay = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
`

export const SelectedCard = styled.div`
  .selected-card {
    border: 2px solid #389e0d !important;
  }
`;